import { MachineStatus } from 'lib_ts/enums/machine.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { capitalize } from 'lodash';

export enum AdminPortalDialog {
  MachineSetting = 'MachineSetting',
  ConfirmInstall = 'ConfirmInstall',
  Details = 'Details',
  EditMachine = 'EditMachine',
  ExportSessions = 'ExportSessions',
  FWUpgradeDate = 'FWUpgradeDate',
  Inspection = 'Inspection',
  Logs = 'Logs',
  Performance = 'Performance',
  PitchReport = 'PitchReport',
  Reassign = 'Reassign',
  RestoreList = 'RestoreList',
  ResetConnections = 'ResetConnections',
  RestartOS = 'RestartOS',
  RestartFW = 'RestartFW',
  ToggleDeleted = 'ToggleDeleted',
}

// currently only used to manipulate the container's scroll position
export const MACHINE_SETTINGS_CONTENT_ID = 'MachineSettingsDialogContent';

export const getMachineStatusColor = (status: MachineStatus) => {
  switch (status) {
    case MachineStatus.NO_BALL:
    case MachineStatus.NEEDS_CALIBRATION:
    case MachineStatus.CALIBRATING:
    case MachineStatus.HEALTH_CHECK:
    case MachineStatus.ESTOP_RECOVERY: {
      return RADIX.COLOR.WARNING;
    }

    case MachineStatus.ERROR:
    case MachineStatus.PROC_DIED:
    case MachineStatus.MULTI_BALL:
    case MachineStatus.ESTOP_ENGAGED: {
      return RADIX.COLOR.DANGER;
    }

    case MachineStatus.R2F: {
      return RADIX.COLOR.SUCCESS;
    }

    case MachineStatus.IDLE:
    case MachineStatus.LOADING:
    case MachineStatus.FIRING:
    default: {
      return RADIX.COLOR.INFO;
    }
  }
};

export const getMachineStatusGroup = (status: MachineStatus) => {
  switch (status) {
    case MachineStatus.CALIBRATING:
    case MachineStatus.ESTOP_RECOVERY:
    case MachineStatus.HEALTH_CHECK:
    case MachineStatus.NEEDS_CALIBRATION:
    case MachineStatus.NEEDS_REALIGNMENT:
    case MachineStatus.NO_BALL:
    case MachineStatus.WRONG_TARGET: {
      return 'Warning';
    }
    case MachineStatus.ERROR:
    case MachineStatus.ESTOP_ENGAGED:
    case MachineStatus.MULTI_BALL:
    case MachineStatus.PROC_DIED: {
      return 'Error';
    }
    case MachineStatus.R2F: {
      return 'Ready';
    }

    case MachineStatus.FIRING:
    case MachineStatus.IDLE:
    case MachineStatus.LOADING:
    case MachineStatus.RELAY_RESTART:
    case MachineStatus.UPGRADING:
    default: {
      return 'Default';
    }
  }
};

export const getMachineStatusDisplay = (status: MachineStatus): string => {
  const split = status.split('_');

  const titleCased = split.map((word) => {
    switch (word) {
      case 'ESTOP': {
        return 'E-Stop';
      }

      case 'R2F': {
        return 'R2F';
      }

      default: {
        return capitalize(word);
      }
    }
  });

  return titleCased.join(' ');
};
export enum MachinesView {
  DefaultView = 'Default View',
  TrainingPerformance = 'Training Performance',
}
